module.exports = "<table class=\"middleContainer2\">\r\n    <tr>\r\n        <td>\r\n            <div class=\"loginMiddle\">\r\n                <small-login-form></small-login-form>\r\n            </div>\r\n        </td>\r\n    </tr>\r\n</table>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/component/login/smallConcise/SmallConcise.html
// module id = 112
// module chunks = 0